// extracted by mini-css-extract-plugin
export var drawerPaper = "_14-0";
export var itemCard = "_14-1";
export var itemImage = "_14-2";